/** Practitioner-facing label for a BN period's provenance (INP-508 stores
 *  the raw `source`; this renders it). A period added through the timeline
 *  editor is `practitioner` — i.e. manually entered. Pure so the mapping is
 *  unit-tested; unknown/new sources fall back to the raw value. */
const BN_SOURCE_LABELS: Record<string, string> = {
  practitioner: 'Manually entered',
  backfill: 'Backfill',
  observed_invoice: 'From invoice',
  import: 'Import',
};

export function bnSourceLabel(source: string): string {
  // Own-property check so inherited keys ("__proto__", "constructor") fall
  // back to the raw value instead of resolving an inherited member.
  return Object.hasOwn(BN_SOURCE_LABELS, source) ? BN_SOURCE_LABELS[source] : source;
}

/** True for the manually-entered (practitioner) source, which the UI
 *  highlights distinctly from the seeded/imported ones. */
export function isManuallyEnteredBnSource(source: string): boolean {
  return source === 'practitioner';
}
